import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import OrderService from "../services/Order";
import Loader from "../component/Loader";
import DefaultImage from "../assets/images/onePlus.jpg";
import ConfirmationModal from "../component/ConfirmationModal";
import ModalComponent from "../component/ModalComponent";
import AlertMsg from "../component/AlertMsg";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import Button from "react-bootstrap/Button";
import OtherService from "../services/Other";
import ThemeTable from "../component/ThemeTable";
import useScrollToTop from "../hooks/useScrollToTop";
import toast from "react-hot-toast";
import NoData from "../component/NoData";
import Skeleton from "react-loading-skeleton";
import ConsentModal from "../component/Modals/ConsentModal";

const MyConsent = () => {
  useScrollToTop();
  const [myOrderData, setMyOrderData] = useState([]);
  const [myOrderNoData, setMyOrderNoData] = useState();
  const [hasData, sethasData] = useState(false);
  const [loading, setLoading] = useState(true);

  const [myOrderList, setMyOrderList] = useState([]);
  const [isConsentOpen, setIsConsentOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const OrderDataFetch = async () => {
    try {
      const res = await OtherService.myConsentList();

      if (JSON.stringify(res) != "{}" && !res.error) {
        const filteredData = res.data.map((item, index) => {
          //   const orderDate = new Date(item.item_status_created_at);
          //   const formattedOrderDate =
          //     orderDate.getDate() +
          //     " " +
          //     getMonthName(orderDate.getMonth() + 1) +
          //     " " +
          //     orderDate.getFullYear() +
          //     ", " +
          //     orderDate.toLocaleTimeString("en-US", {
          //       hour: "numeric",
          //       minute: "numeric",
          //       hour12: true,
          //       timeZone: "UTC",
          //     });
          //   let serialNo = <div className="text-center">{index + 1}</div>;
          const placeHolderImage = (
            <div className="itemWrapImageMyOrder">
              <img src={DefaultImage} alt="image" />
            </div>
          );
          const productName = (
            <div className="text-left productNameBlock">
              {item.product_name}
            </div>
          );
          const orderStatus = (
            <p className="orderTxt text-left">
              {item.order_status === "Cancelled" ? (
                <span className="redDot"></span>
              ) : item.order_status === "Dispatched" ? (
                <span className="orangeDot"></span>
              ) : item.order_status === "Delivered" ? (
                <span className="greenDot"></span>
              ) : (
                <span className="yellowDot"></span>
              )}
              {item.order_status === "Cancelled" ? (
                "Cancelled"
              ) : item.order_status === "Dispatched" ? (
                "Dispatched"
              ) : item.order_status === "Delivered" ? (
                "Delivered"
              ) : (
                <>
                  {/* Ordered On{" "}
                  <span className="orderDate">{formattedOrderDate}</span> */}
                </>
              )}
            </p>
          );
          const actionButtons = (
            <div className="feedbackTrackOrderTxt">
              <PrimaryOutLineButton
                onClick={() => {
                  setIsConsentOpen(true);
                }}
                outlinebuttonText="My Consent"
              />
            </div>
          );

          return {
            "Order Id": <div className="text-center">{item.order_id}</div>,
            "Product Image": placeHolderImage,
            "Product Name": productName,
            Quantity: item.item_quantity,
            "Order Status": orderStatus,
            Actions: actionButtons,
          };
        });
        setMyOrderData(filteredData);
        sethasData(true);
        setLoading(false);
      } else {
        setMyOrderNoData("No Orders are listed");
        setLoading(false);
        sethasData(false);
      }
    } catch (error) {
      console.error("OrderDataFetch");
      setLoading(false);
      sethasData(false);
      setMyOrderNoData("No Orders are listed");
    }
  };
  useEffect(() => {
    OrderDataFetch();
  }, []);

  // const loadOrders = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await OtherService.myConsentList();

  //     if (JSON.stringify(res) != "{}" && !res.error) {
  //       setLoading(false);
  //       setMyOrderList(res.data);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("loadOrders error");
  //   }
  // };
  // useEffect(() => {
  //   loadOrders();
  // }, []);

  function getMonthName(month) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[month - 1];
  }

  return (
    <>
      <BreadCrumbSecttion pageTitle="My Consent" currentPageName="My Consent" />
      <section className="padTop50">
        <Container>
          {!loading && myOrderData.length === 0 && <NoData />}
          <Row>
            <Col xs={12} lg={4} className="my-4"></Col>
          </Row>
          {myOrderData.length === 0 && loading && <Skeleton height={50} />}
          {myOrderData.length > 0 && (
            <Row>
              <Col xs={12}>
                <ThemeTable showLodeMoreBtn={false} data={myOrderData} />
              </Col>
            </Row>
          )}

          <ConsentModal
            page="consent"
            setIsModalOpen={setIsConsentOpen}
            isModalOpen={isConsentOpen}
            modalTitle="Please provide your consent"
            modalDescription="Hello World"
            onConsentSubmit={(selected) => {
              setIsConsentOpen(false);
            }}
            consentOptions={[
              "Yes, I have received",
              "Received, but damaged",
              "No, I haven't received",
            ]}
          />
        </Container>
      </section>
    </>
  );
};

export default MyConsent;
